module.exports = __webpack_public_path__ + "img/graph.554b91e7.svg";